export const aciStarFillHalf = {
    iconName: 'star-fill-half',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M12.592 3.357l2.673 5.303 5.145.51a.642.642 0 01.574.783.644.644 0 01-.174.317l-4.235 4.202 1.57 5.71a.651.651 0 01-.92.749l-5.215-2.587-5.21 2.583a.649.649 0 01-.919-.747l1.57-5.711-4.237-4.203a.644.644 0 01.4-1.099l5.144-.51 2.67-5.3a.655.655 0 011.164 0z',
                    stroke: 'currentColor',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M11.824 3.093c-.103.007.144.008.055.062-.103.063-.35-.082-.405.025l-.441.875-2.09 4.396-1.76.19-3.523.35a.644.644 0 00-.55.42.646.646 0 00.15.677l4.238 4.203-1.57 5.711a.648.648 0 00.558.813.647.647 0 00.361-.065l5.202-2.58z',
                    fill: 'currentColor',
                    stroke: 'currentColor',
                },
            },
        ],
    },
};
